module.exports = __webpack_public_path__ + "static/media/image-not-supported.44fc9fa5.svg";